/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Row, Col, Pagination, Spin, Button, Tooltip, Divider, message, Select, Input, Tag, DatePicker } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import moment from 'moment';

import {
  FilterOutlined
} from '@ant-design/icons';
import Routes from '../../routing/routes'
import Table from '../../components_new/table'
import Utils from '../../helpers/Utility';
import issueTrackerService from '../../services/issueTrackerServices'
import authStore from '../../store/authStore';
import organizationService from '../../services/organizationService';
import IssuetrackerOverviewCard from '../../components_new/issue-tracker-overview-card';
import IssueTrackerFilterDrawer from '../../components_new/issue-tracker-filterdrawer';
import IssueTrackerExportModal from '../../components_new/issue-tracker-export-modal';

import constants from '../../config/constants';
import _ from "lodash";
import userService from '../../services/userService';
import { readInsightsTicketsListState } from '../../helpers/insightsTicketsNav';

const { Option } = Select;
const { Search } = Input;
const { RangePicker } = DatePicker;

const DATE_FILTER_FORMAT = 'MM-DD-YYYY';

function formatDateFilters(range: any) {
  return {
    startDate: range?.[0] ? range[0].format(DATE_FILTER_FORMAT) : undefined,
    endDate: range?.[1] ? range[1].format(DATE_FILTER_FORMAT) : undefined,
  };
}

const disableFutureDate = (current: any) => current && current > moment().endOf('day');

function pickUserRoleFilterIds(filterBag: any) {
  return {
    consumer: filterBag?.consumer?.[0]?._id ? [filterBag.consumer[0]._id] : null,
    contractor: filterBag?.contractor?.[0]?._id ? [filterBag.contractor[0]._id] : null,
    resolved_by: filterBag?.service_resolved_by?.[0]?._id ? [filterBag.service_resolved_by[0]._id] : null,
  };
}

function extractIssueTrackerGroupingIds(filterBag: any): { group_ids: string[] | null; sensorbox_ids: string[] | null } {
  const groupSet = new Set<string>();
  const sensorboxSet = new Set<string>();

  const pushRef = (set: Set<string>, ref: any) => {
    if (ref == null) return;
    const id = typeof ref === 'object' && ref?._id != null ? ref._id : ref;
    if (id != null) set.add(String(id));
  };

  if (filterBag?.sensorbox_group?.[0]?._id) {
    pushRef(groupSet, filterBag.sensorbox_group[0]._id);
  }
  const agEntry = filterBag?.asset_group?.[0];
  if (agEntry) {
    (agEntry.assets || []).forEach((a: any) => pushRef(groupSet, a));
    (agEntry.sensorboxes || []).forEach((s: any) => pushRef(sensorboxSet, s));
  }

  return {
    group_ids: groupSet.size ? Array.from(groupSet) : null,
    sensorbox_ids: sensorboxSet.size ? Array.from(sensorboxSet) : null,
  };
}

const userTypes = new Map([
  ['consumer', 'User'],
  ['contractor', 'Contractor'],
  ['service_resolved_by', 'Resolved By'],
  ['sensorbox_group', 'Asset'],
  ['asset_group', 'Org / Asset Group'],
  ['OPEN','Open'],
  ['CLOSED','Closed'],
  ['IGNORED','Ignored'],
  ['MISSED','Missed'],
  ['RESOLVED','Resolved'],
  ['PENDING REVIEW', 'Pending Review'],
  ['INCOMPLETE', 'Incomplete']
])

function IssuetrackerListing() {

  let history = useHistory();
  const location = useLocation() as any;
  const savedListState = readInsightsTicketsListState(location)

  const [issues, setIssues] = useState<any>([]);
  const [issuesOverview, setIssuesOverview] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [searchFilter, setSearchFilter] = useState(savedListState?.searchFilter || '')
  const [organizationFilterData, setOrganizationFilterData] = useState([]) //org
  const [selectedFilter, setSelectedFilter] = useState(savedListState?.selectedFilter || '') //org
  const [totalCount, setTotalCount] = useState(0)
  const [technicianUnderContractor, setTechnicianUnderContractor] = useState([])
  const [page, setPage] = useState(savedListState?.page || 1);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [exportVisible, setExportVisible] = useState(false);
  const [filterData, setFilterData] = useState<any>(savedListState?.filterData || {});
  const [dateRange, setDateRange] = useState<any>(
    savedListState?.dateRange?.length === 2
      ? [moment(savedListState.dateRange[0], DATE_FILTER_FORMAT), moment(savedListState.dateRange[1], DATE_FILTER_FORMAT)]
      : null
  );

  const organizationDropDownCondition = authStore?.isSuperAdmin || (authStore?.isOrgAdmin() && authStore.currentUser.is_default)

  // Memoized so the export modal does not refetch its count on every re-render.
  const groupingIds = React.useMemo(() => extractIssueTrackerGroupingIds(filterData), [filterData])
  const exportDateFilters = formatDateFilters(dateRange)

  useEffect(() => {
    sessionStorage.removeItem('insightsTicketsListState')
    if (organizationDropDownCondition) {
      getIssuesWithOrganizationDetails()
    } else {
      fetchIssueTracker(page, searchFilter, selectedFilter || undefined, filterData?.status, filterData)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const { startDate, endDate } = formatDateFilters(dateRange)
    history.replace({
      pathname: Routes.issuetracker,
      state: {
        listState: {
          searchFilter,
          selectedFilter,
          page,
          filterData,
          dateRange: startDate && endDate ? [startDate, endDate] : null,
        },
      },
    })
  }, [searchFilter, selectedFilter, page, filterData, dateRange])

  const fetchIssueTracker = async (pageNumber: number = 0, searchKeyword: string = '', orgid?: any, status?: any, filterBag?: any, refreshOverview: boolean = true, rangeBag?: any) => {

    pageNumber = pageNumber === 0 ? page : pageNumber;
    const fd = filterBag !== undefined ? filterBag : filterData;
    const { consumer, contractor, resolved_by } = pickUserRoleFilterIds(fd);
    const { group_ids, sensorbox_ids } = extractIssueTrackerGroupingIds(fd);
    const { startDate, endDate } = formatDateFilters(rangeBag !== undefined ? rangeBag : dateRange);

    try {
      setLoading(true)
      const [issuesTrackerDatas, issuesOverview] = await Promise.all([
        issueTrackerService.getIssueTrackerDetails(
          pageNumber,
          constants.maxLimit,
          orgid,
          status,
          consumer,
          contractor,
          resolved_by,
          searchKeyword,
          startDate,
          endDate,
          undefined,
          undefined,
          group_ids,
          sensorbox_ids,
        ),
        refreshOverview
          ? issueTrackerService.getIssueTrackerOverview(
              orgid,
              consumer,
              contractor,
              resolved_by,
              searchKeyword,
              group_ids,
              sensorbox_ids,
              startDate,
              endDate,
            )
          : Promise.resolve(null),
      ])
      const technicianList = authStore?.currentUser?.active_role?.role_type === constants.role.Contractor ? true : false
      if (technicianList) {
      const technicianUnserContractor = await userService.getUserBasedOnRoleType(orgid, constants.role['Field Technician'], technicianList)
        setTechnicianUnderContractor(technicianList ? technicianUnserContractor?.technicianList : [])
      }
      setTotalCount(issuesTrackerDatas?.count)
      setIssues(issuesTrackerDatas?.issues)
      if (issuesOverview) {
        setIssuesOverview(issuesOverview?.issuesCounts)
      }
      setLoading(false)
      setPage(pageNumber)
    } catch (error) {
      setLoading(false)
      message.error(error?.response?.data?.message)
    }
  }

  const getIssuesWithOrganizationDetails = async () => {

    try {
      const response = await organizationService.getOrganizations()
      const organizations = response.data.organizations || []
      setOrganizationFilterData(organizations);
      const savedOrgStillValid = selectedFilter && organizations.some((org: any) => org._id === selectedFilter)
      const orgid = savedOrgStillValid ? selectedFilter : organizations[0]?._id
      setSelectedFilter(orgid)
      fetchIssueTracker(page, searchFilter, orgid, filterData?.status, filterData)
    } catch (error) {
      setLoading(false)
      message.error(error?.response?.data?.message)
    }
  }

  const searchDebounce = React.useCallback(_.debounce(fetchIssueTracker, 700), [])

  const handleSearchFilter = (e: any) => {
    const { value } = e.target;
    setSearchFilter(value);

    searchDebounce(1, value, selectedFilter, filterData?.status, filterData, true, dateRange)
  };

  const handleDateRangeChange = (dates: any) => {
    const range = dates && dates[0] && dates[1] ? [dates[0], dates[1]] : null;
    setDateRange(range);

    fetchIssueTracker(1, searchFilter, selectedFilter, filterData?.status, filterData, true, range)
  };

  const onPageChange = (page: any) => {

    fetchIssueTracker(page, searchFilter, selectedFilter, filterData?.status, filterData, false)
  };

  const columns = [
    {
      title: 'Title',
      dataIndex: 'issue_title',
      key: 'issue_title',
      ellipsis: {
        showTitle: false,
      },
      render: (name: {} | null | undefined) => (
        <Tooltip placement="topLeft" title={name}>
          {name}
        </Tooltip>
      ),
      // width: '10%',
      align: 'left' as const,
    }
    ,
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      ellipsis: {
        showTitle: false,
      },
      render: (description: string | null | undefined) => {
        const fullDescription = description || '-';
        const trimmedDescription =
          fullDescription.length > 40
            ? `${fullDescription.substring(0, 40)}...`
            : fullDescription;

        return (
          <Tooltip placement="topLeft" title={fullDescription}>
            {trimmedDescription}
          </Tooltip>
        );
      },
      align: 'left' as const,
    },
    {
      title: 'System',
      key: 'system',
      dataIndex: 'system',
      ellipsis: {
        showTitle: false,
      },
      render: (name: {} | null | undefined) => (
        <Tooltip placement="topLeft" title={name}>
          {name}
        </Tooltip>
      ),
      width: '15%',
      align: 'left' as const,
    }
    ,
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      render: (data: any) => (
        <>
          <Tag color={Utils.getIssueTrackerStatus(data)} key={data}>
            {data.toUpperCase()}
          </Tag>
        </>
      ),
      width: '8%',
      align: 'left' as const,
      ellipsis: {
      showTitle: false,
  },
    },
    {
      title: 'Days Open',
      key: 'daysopen',
      dataIndex: 'daysopen',
      ellipsis: {
        showTitle: false,
      },
      render: (name: {} | null | undefined) => (
        <Tooltip placement="topLeft" title={name}>
          {name}
        </Tooltip>
      ),
      width: '10%',
      align: 'left' as const,
    }
    ,
    {
      title: 'Ticket ID',
      dataIndex: 'issue_id',
      key: 'issue_id',
      ellipsis: {
        showTitle: false,
      },
      render: (name: {} | null | undefined) => (
        <Tooltip placement="topLeft" title={name}>
          {name}
        </Tooltip>
      ),
      width: '10%',
      align: 'left' as const,
    }
  ];

  const tableDatas = issues?.map((issue: any, index: number) => {
    const system_name = issue.group_id?.name
      ? issue?.group_id?.name
        : issue?.sensor_box?.alias
        ? issue?.sensor_box?.alias
        : issue?.sensor_box?.sensor_box_name;

    let daysOpen = (issue.status === 'OPEN') ? Utils.getMomentFromNow(issue?.created_on) : ''

    let hardSavingsRevenue = issue?.hard_savings?.reduce((accumulator: any, object: any) => {
      return accumulator + object?.savings_amount;
    }, 0);

    let powerSavingsRevenue = issue?.power_savings?.reduce((accumulator: any, object: any) => {
      return accumulator + object?.savings_amount;
    }, 0);

    let result: any = {
      _id: issue?._id,
      key: index + 1,
      issue_id: issue?.issue_id,
      consumer: issue?.consumer ? issue?.consumer?.name : '',
      issue_title: issue?.issue_title,
      description: issue?.issue_description,
      issue_priority: issue?.issue_priority,
      issue_assigned_to: issue?.assigned_to,
      assigned_contractor: issue?.sensor_box?.contractor?.find((element: { _id: string; name: string}) => element?._id === issue?.contractor?._id) ? issue?.contractor?.name : '-',
      system: system_name,
      daysopen: daysOpen,
      hard_savings_revenue: hardSavingsRevenue ? `$ ${(Math.round(hardSavingsRevenue * 100) / 100).toLocaleString()}` : '-',
      power_savings_revenue: powerSavingsRevenue ? `$ ${(Math.round(powerSavingsRevenue * 100) / 100).toLocaleString()}` : '-',
      mechasense_service_revenue: issue?.mechasense_service_revenue ? `$ ${(Math.round(issue?.mechasense_service_revenue * 100) / 100).toLocaleString()}` : '-',
      contractor_service_revenue: issue?.contractor_service_revenue ? `$ ${(Math.round(issue?.contractor_service_revenue * 100) / 100).toLocaleString()}` : '-',
      status: issue?.status
    };
    return result
  })

  const onSelectRow = (record: any) => {
    let params = `?ticket_id=${record?._id}`
    if (organizationDropDownCondition) {
      params += `&org_id=${selectedFilter}`
    }

    const { startDate, endDate } = formatDateFilters(dateRange)

    history.push({
      pathname: `${Routes.issuetrackerdetails}`,
      search: params,
      state: {
        listState: {
          searchFilter,
          selectedFilter,
          page,
          filterData,
          dateRange: startDate && endDate ? [startDate, endDate] : null,
        },
      },
    });
  }

  const showDrawer = () => {
    setDrawerVisible(true);
  };

  const onCloseDrawer = () => {
    setDrawerVisible(false);

    fetchIssueTracker(page, searchFilter, selectedFilter, filterData?.status, filterData)
  };

  const onHandleFilterOnCard = (status: any) => {

    const data = { ...filterData };
    data[`status`] = [status]
    setFilterData(data);

    fetchIssueTracker(1, searchFilter, selectedFilter, [status], data)
  }

  const onApplyFilter = (values: any) => {

    setFilterData(values)

    fetchIssueTracker(1, searchFilter, selectedFilter, values?.status, values)
    setDrawerVisible(false);
  }

  const handleClearAll = () => {
    setFilterData({});
    setDateRange(null);
    fetchIssueTracker(1, searchFilter, selectedFilter, null, {}, true, null)
    setDrawerVisible(false)
  }

  const onCloseTags = (key: any, tag: any) => {
    const statusData = { ...filterData };
    if (key === 'status') {
      statusData['status'] = statusData?.status?.filter((status: any) => status !== tag)
      if (!(statusData?.status?.length)) {
        delete statusData[key];
      }
    } else {
      delete statusData[key];
    }
    setFilterData(statusData);

    fetchIssueTracker(1, searchFilter, selectedFilter, statusData?.status, statusData)
  }

  const handleFilterSelection = (option: any) => {
    setSelectedFilter(option)

    fetchIssueTracker(1, searchFilter, option, filterData?.status, filterData)
  }

  const openIssuesCount = issuesOverview?.find((issue: any) => issue?.status === 'OPEN')
  const closedIssuesCount = issuesOverview?.find((issue: any) => issue?.status === 'CLOSED')
  const missedIssuesCount = issuesOverview?.find((issue: any) => issue?.status === 'MISSED')
  const resolvedIssuesCount = issuesOverview?.find((issue: any) => issue?.status === 'RESOLVED')
  const pendingReviewsCount = issuesOverview?.find((issue: any) => issue?.status === 'PENDING REVIEW')
  const incompleteIssuesCount = issuesOverview?.find((issue: any) => issue?.status === 'INCOMPLETE')
  const exportDisabled = organizationDropDownCondition && !selectedFilter

  return (
    <div className="p-0">
      <Spin spinning={loading}>
        <div className="d-flex flex-column h-100 overflow-hidden p-0">
          <div className="flex-fill h-100 overflow-hidden issue-tracker-padding">
            <div className="d-flex flex-wrap align-items-start">
              <div className="flex-fill">
                <p className="page-title text-left">Insights / Tickets
                  <i
                    className={`fa fa-download ml-3 ${exportDisabled ? '' : 'cursor-pointer'}`}
                    onClick={() => { if (!exportDisabled) setExportVisible(true) }}
                    aria-hidden="true"
                    title="Export Tickets"
                    style={{ fontSize: '18px', color: '#ffffff', display: 'inline-block', backgroundColor: '#4F8C92', borderRadius: '6px', padding: '9px', opacity: exportDisabled ? 0.5 : 1 }}
                  ></i>
                </p>
              </div>
              <div className="d-flex flex-wrap align-items-center justify-content-end mb-3">

                {
                  (organizationDropDownCondition) &&
                  <Select
                    className='mr-3'
                    value={selectedFilter}
                    onChange={handleFilterSelection}
                    size="large"
                    style={{ width: 200, flexShrink: 0 }}>
                    {
                      organizationFilterData &&
                      organizationFilterData.map((data: any) => {
                        return (
                          <Option value={data._id}>{data.name}</Option>
                        );
                      })
                    }
                  </Select>

                }
                <RangePicker
                  className='mr-3'
                  size="large"
                  format={DATE_FILTER_FORMAT}
                  value={dateRange}
                  onChange={handleDateRangeChange}
                  disabledDate={disableFutureDate}
                  style={{ width: 260, flexShrink: 0 }}
                  allowClear />

                <Search
                  className='mr-3'
                  placeholder="Search"
                  value={searchFilter || ""}
                  size="large"
                  onChange={handleSearchFilter}
                  style={{ width: 240, flexShrink: 0 }}
                  allowClear
                  enterButton />

                <Button type="text" icon={<FilterOutlined />} size="large" style={{ flexShrink: 0 }} onClick={showDrawer}>Filter</Button>
                <IssueTrackerExportModal
                  visible={exportVisible}
                  orgid={selectedFilter}
                  searchFilter={searchFilter}
                  filterData={filterData}
                  groupIds={groupingIds.group_ids}
                  sensorboxIds={groupingIds.sensorbox_ids}
                  startDate={exportDateFilters.startDate}
                  endDate={exportDateFilters.endDate}
                  onClose={() => setExportVisible(false)}
                />
                <IssueTrackerFilterDrawer
                  data={filterData}
                  orgid={selectedFilter}
                  visible={drawerVisible}
                  onCloseDrawer={onCloseDrawer}
                  onApplyFilter={onApplyFilter}
                  onClearAll={handleClearAll}
                />
              </div>
            </div>

            {(Object.values(filterData).length > 0 || dateRange) &&
              <>
                <Divider
                  type="horizontal"
                  style={{ backgroundColor: "#000", margin: "auto" }}
                />
                <div className='mb-2'>
                  <Row gutter={[16, 16]}>
                    <Col span={22}>

                      {
                        Object.keys(filterData).map((key: any) => {
                          return filterData[key]?.map((tag: any) => (

                            <Tag className='mt-3 h6' color="grey" closable onClose={(e: any) => { onCloseTags(key, tag); e.preventDefault(); }}>
                              {key === 'status' ? userTypes.get(tag) : tag.name} {key !== 'status' && <span className='ml-2 text-uppercase font-weight-bold'>
                                {userTypes.get(key)}
                              </span>}
                            </Tag>
                          ))
                        })
                      }

                      {dateRange &&
                        <Tag className='mt-3 h6' color="grey" closable onClose={(e: any) => { handleDateRangeChange(null); e.preventDefault(); }}>
                          {exportDateFilters.startDate} - {exportDateFilters.endDate}
                          <span className='ml-2 text-uppercase font-weight-bold'>Date Range</span>
                        </Tag>
                      }

                    </Col>
                    <Col span={2}>
                      <p className='mt-3 float-right'> <a href="/" style={{ color: '#4F8C92', fontWeight: 600 }} onClick={(e: any) => { handleClearAll(); e.preventDefault(); }}>
                        CLEAR ALL
                      </a></p>
                    </Col>
                  </Row>
                </div>
                <Divider
                  type="horizontal"
                  style={{ backgroundColor: "#000", margin: "auto" }}
                />
              </>
            }

            <div className="mb-3">
              <Row gutter={[8, 8]}>
                <Col span={4}>
                  <IssuetrackerOverviewCard
                    count={openIssuesCount ? openIssuesCount?.count : 0}
                    description={<Tag color={Utils.getIssueTrackerStatus('OPEN')} key={'OPEN'}>{'OPEN'}</Tag>}
                    onHandleFilterOnCard={() => onHandleFilterOnCard('OPEN')}
                  />
                </Col>
                <Col span={4}>
                  <IssuetrackerOverviewCard
                    count={pendingReviewsCount ? pendingReviewsCount?.count : 0}
                    description={<Tag color={Utils.getIssueTrackerStatus('PENDING REVIEW')} key={'PENDING REVIEW'}>{'PENDING REVIEW'}</Tag>}
                    onHandleFilterOnCard={() => onHandleFilterOnCard('PENDING REVIEW')}
                  />
                </Col>
                <Col span={4}>
                  <IssuetrackerOverviewCard
                    count={resolvedIssuesCount ? resolvedIssuesCount?.count : 0}
                    description={<Tag color={Utils.getIssueTrackerStatus('RESOLVED')} key={'RESOLVED'}>{'RESOLVED'}</Tag>}
                    onHandleFilterOnCard={() => onHandleFilterOnCard('RESOLVED')}
                  />
                </Col>
                <Col span={4}>
                  <IssuetrackerOverviewCard
                    count={missedIssuesCount ? missedIssuesCount?.count : 0}
                    description={<Tag color={Utils.getIssueTrackerStatus('MISSED')} key={'MISSED'}>{'MISSED'}</Tag>}
                    onHandleFilterOnCard={() => onHandleFilterOnCard('MISSED')}
                  />
                </Col>
                <Col span={4}>
                  <IssuetrackerOverviewCard
                    count={incompleteIssuesCount ? incompleteIssuesCount?.count : 0}
                    description={<Tag color={Utils.getIssueTrackerStatus('INCOMPLETE')} key={'INCOMPLETE'}>{'INCOMPLETE'}</Tag>}
                    onHandleFilterOnCard={() => onHandleFilterOnCard('INCOMPLETE')}
                  />
                </Col>
                <Col span={4}>
                  <IssuetrackerOverviewCard
                    count={closedIssuesCount ? closedIssuesCount?.count : 0}
                    description={<Tag color={Utils.getIssueTrackerStatus('CLOSED')} key={'CLOSED'}>{'CLOSED'}</Tag>}
                    onHandleFilterOnCard={() => onHandleFilterOnCard('CLOSED')}
                  />
                </Col>
              </Row>
            </div>
            <div className='style-table'>
              <Table
                data={tableDatas}
                columns={columns}
                onSelectRow={(record: any) => onSelectRow(record)}
              />
            </div>

            <div className='py-4'>
              {Math.ceil(totalCount / constants.maxLimit) > 1 &&
                <Pagination
                  defaultCurrent={1}
                  current={page}
                  total={totalCount}
                  pageSize={constants.maxLimit}
                  responsive={true}
                  className="float-right"
                  showSizeChanger={false}
                  onChange={onPageChange} />
              }
            </div>
          </div>
        </div>
      </Spin>
    </div>
  );
}
export default IssuetrackerListing;